// 0 = empty, 1 = weak, 2 = fair, 3 = strong, 4 = very strong
export const passwordScore = (pw) => {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 8) s += 1;
  if (pw.length >= 12) s += 1;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s += 1;
  if (/\d/.test(pw)) s += 1;
  if (/[^A-Za-z0-9]/.test(pw)) s += 1;
  if (pw.length < 6) return 1;
  return Math.max(1, Math.min(4, Math.round((s / 5) * 4)));
};
